export enum AppConfigValueType {
  JsonObject = 'json_object',
  JsonArray = 'json_array',
}
